module.exports = __webpack_public_path__ + "427da44a8aa6b6b4fa503fb41618ab2e.svg";